export default "__VITE_ASSET__B0z6CUIj__"